import { useFileInfo } from 'BreetHooks';

import type { IFileView } from '../FileInput.helpers';
import { FilePostSelect } from './PostSelect';
import { FilePreFileSelect } from './PreSelect';

const FileSelect = ({ acceptedMimeTypes, value, onPreview, onReplace }: IFileView) => {
	const file = typeof value === 'string' ? value : value?.[0];

	const { mimeType, name } = useFileInfo(file);

	return (
		<>
			{!value ? (
				<FilePreFileSelect acceptedMimeTypes={acceptedMimeTypes} />
			) : (
				<FilePostSelect
					fileName={name}
					mimeType={mimeType}
					onPreview={onPreview}
					onReplace={onReplace}
				/>
			)}
		</>
	);
};

export default FileSelect;

FileSelect.displayName = 'FileSelect';
